<template>
        <div class="card-body" data-testid="documents">
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
                <div class="dropbox">
                    <input type="file"
                           :name="uploadFieldName"
                           multiple
                           :disabled="isSaving"
                           @change="filesChange($event.target.name, $event.target.files)"
                           class="input-file"
                           data-testid="document-upload">
                    <p v-if="isInitial">
                        Sem přetáhni soubory, nebo kliknu pro nahrání
                    </p>
                    <p v-if="isSaving" data-testid="document-upload-status">
                        Nahrávám {{ fileCount }} soubor...
                    </p>
                </div>
            </form>

          <document-list :reload="reloadList" @listReloaded="reloadList = false"/>
        </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import DocumentList from './DocumentList.vue'
  // import { upload } from '@/services/file-upload'

  const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  const STATUS_SUCCESS = 2
  const STATUS_FAILED = 3

  export default {
    name: 'app',
    data () {
      return {
        uploadedFiles: [],
        uploadError: null,
        currentStatus: null,
        uploadPending: false,
        uploadDone: false,
        uploadFieldName: 'files',
        fileCount: 0,
        previewFiles: [],
        imgFiles: null,
        reloadList: false
      }
    },
    mixins: [apiMixin],
    computed: {
      isInitial () {
        return this.currentStatus === STATUS_INITIAL
      },
      isSaving () {
        return this.currentStatus === STATUS_SAVING
      },
      isSuccess () {
        return this.currentStatus === STATUS_SUCCESS
      },
      isFailed () {
        return this.currentStatus === STATUS_FAILED
      }
    },
    watch: {
      uploadDone: function (val) {
        if (val === true) {
          this.reloadList = true
          this.reset()
        }
      }
    },
    methods: {
      reset () {
        this.currentStatus = STATUS_INITIAL
        this.uploadedFiles = []
        this.uploadError = null
        this.fileCount = 0
      },
      save (formData) {
        this.uploadDone = false
        // upload data to the server
        this.currentStatus = STATUS_SAVING

        this.uploadFile(formData)
      },
      filesChange (fieldName, fileList) {
        let self = this
        // handle file changes
        const formData = new FormData()

        if (!fileList.length) return
        this.fileCount = fileList.length

        for (let i = 0; i < fileList.length; i++) {
          let file = fileList[i]
          let picReader = new FileReader()

          if (file.type.match('image')) {
            picReader.addEventListener('load', function (event) {
              let picFile = event.target
              self.previewFiles[i] = picFile.result
            })
            picReader.readAsDataURL(file)
          }

          this.$emit('input', fileList[0])
          formData.append('files[' + i + ']', file)
          if (this.$route.params.visitid) {
            formData.append('visit_id', this.$route.params.visitid)
          }
          formData.append('client_id', this.$route.params.clientid)
        }

        this.$nextTick(function () {
          // this.imgFiles = this.previewFiles
        })

        // save it
        this.save(formData)
      }
    },
    mounted () {
      this.reset()
    },
    components: {
      DocumentList
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .dropbox {
        outline: 2px dashed grey; /* the dash box */
        outline-offset: -10px;
        background: lightcyan;
        color: dimgray;
        padding: 10px 10px;
        min-height: 40px; /* minimum height */
        position: relative;
        cursor: pointer;
    }

    .input-file {
        opacity: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        cursor: pointer;
        margin-left: -10px;
        margin-top: -10px;
    }

    .dropbox:hover {
        background: lightblue; /* when mouse over to the drop zone, change color */
    }

    .dropbox p {
        font-size: 1em;
        text-align: center;
        padding: 10px 0;
        margin-bottom: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/Document/DocumentComponent.vue?201c203e